/*
 * Returns an object describing the current state of properties/attributes
 * in the native select node
 */
export default function (node) {
  return {
    disabled: node.property('disabled') || node.classed('disabled'),
    multiple: node.property('multiple')
  }
}
